// Centralized helpers for History page selection persistence

const KEYS = {
  lastPage: 'history:lastPage',
  selectedCaseId: 'history:selectedCaseId',
} as const;

const safeLocalStorage = () =>
  typeof window !== 'undefined' ? window.localStorage : null;

export function getSavedLastPage(): number {
  const ls = safeLocalStorage();
  const raw = ls?.getItem(KEYS.lastPage) ?? null;
  const n = raw ? parseInt(raw, 10) : NaN;
  return Number.isFinite(n) && n > 0 ? n : 1;
}

export function setSavedLastPage(page: number): void {
  const ls = safeLocalStorage();
  if (!ls) return;
  ls.setItem(KEYS.lastPage, String(page));
}

export function getSavedSelectedCaseId(): number | null {
  const ls = safeLocalStorage();
  const raw = ls?.getItem(KEYS.selectedCaseId) ?? null;
  const n = raw ? parseInt(raw, 10) : NaN;
  return Number.isFinite(n) ? n : null;
}

export function setSavedSelection(caseId: number | null, page: number): void {
  const ls = safeLocalStorage();
  if (!ls) return;
  ls.setItem(KEYS.lastPage, String(page));
  if (caseId != null) {
    ls.setItem(KEYS.selectedCaseId, String(caseId));
  }
}

export function clearHistorySelection(): void {
  const ls = safeLocalStorage();
  if (!ls) return;
  ls.removeItem(KEYS.lastPage);
  ls.removeItem(KEYS.selectedCaseId);
}
